/**
 * Grundbuchmeldung API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EreignisFileZuMeldungEntry } from './ereignisFileZuMeldungEntry';
import { GrundbuchmeldungId } from './grundbuchmeldungId';
import { GbGeschaeftId } from './gbGeschaeftId';
import { GeschaeftsnummerEntry } from './geschaeftsnummerEntry';
import { MeldungsEmpfaengerId } from './meldungsEmpfaengerId';


export interface EchGrundbuchmeldungListEntry { 
    id: MeldungsEmpfaengerId;
    meldungId: GrundbuchmeldungId;
    gbGeschaeftId: GbGeschaeftId;
    geschaeftsnummer?: GeschaeftsnummerEntry;
    meldungsStatus?: EchGrundbuchmeldungListEntry.MeldungsStatusEnum;
    datumMeldung?: Date;
    empfaengerBezeichnung?: string;
    empfaengerSedexId?: string;
    isVertraulich?: boolean;
    statusResetPossible?: boolean;
    viewEmpfaengerPossible?: boolean;
    ereignisFiles?: Array<EreignisFileZuMeldungEntry>;
    basedeliveryFileId?: string;
}
export namespace EchGrundbuchmeldungListEntry {
    export type MeldungsStatusEnum = 'NICHT_ERSTELLT' | 'ERSTELLT' | 'FEHLERHAFT_ERSTELLT' | 'FEHLERHAFT_GESENDET' | 'GESENDET';
    export const MeldungsStatusEnum = {
        NICHT_ERSTELLT: 'NICHT_ERSTELLT' as MeldungsStatusEnum,
        ERSTELLT: 'ERSTELLT' as MeldungsStatusEnum,
        FEHLERHAFT_ERSTELLT: 'FEHLERHAFT_ERSTELLT' as MeldungsStatusEnum,
        FEHLERHAFT_GESENDET: 'FEHLERHAFT_GESENDET' as MeldungsStatusEnum,
        GESENDET: 'GESENDET' as MeldungsStatusEnum
    };
}


